module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal share animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('img', {
    attrs: {
      "src": "/images/logo.png"
    }
  }), _vm._v(" "), _c('h3', [_c('span', [_vm._v("XOXO")]), _vm._v(_vm._s(_vm.$t('share_modal.spread_the_love')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('share_modal.message')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social-icons"
  }, [_c('a', {
    staticClass: "social_share_link twitter",
    attrs: {
      "href": "https://twitter.com/intent/tweet?text=Have%20you%20guys%20checked%20out%20%40WorkpapersApp%20yet%3F%20I%20love%20it!%20%23proposals%20https%3A%2F%2workapers.io"
    }
  }, [_c('i', {
    staticClass: "icon icon-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "social_share_link facebook",
    attrs: {
      "href": "https://www.facebook.com/dialog/feed?app_id=184683071273&link=https%3A%2F%2Fworkpapers.io&picture=&name=Workpapers%20Proposal%20Software&caption=%20&description=Simple%20%26%20elegant%20proposal%20software%20for%20freelancers%20and%20small%20to%20medium%20sized%20agencies.&redirect_uri=https%3A%2F%2Fwww.facebook.com%2F"
    }
  }, [_c('i', {
    staticClass: "icon icon-facebook"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-100eafed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/share-modal.vue
// module id = 506
// module chunks = 0